<template>
   <div>
      <!--顶部日期搜索-->
      <el-row :gutter="20" style="margin-bottom: 20px;">
         <el-col :span="3">
            <el-date-picker
                    v-model="queryInfo.date"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    @change="changeData">
            </el-date-picker>
         </el-col>
          <el-col :span="2" :offset="19">
              <el-button v-permission="['BUSINESS-USER-PROJECT-FOCUS']" type="primary" icon="el-icon-setting" @click="showSetDialog">设置</el-button>
          </el-col>
      </el-row>
      <!--<vxe-table :data="tablelist" ref="xTable" border style="width: 100%" :height="treeTableHeight">
         <vxe-column v-for="item in columns"
                      :field="item.prop"
                      :title="item.label"
                      :key="item.prop"
                      :type="item.type"
                      :fixed="item.prop==='DNT' ? 'left': ''"
                      :width="item.prop==='DNT' ? 160:80">
         </vxe-column>
      </vxe-table>-->
       <!--width="80px" -->
       <el-table border stripe checkBox ref="xTable"  :height="treeTableHeight" :data="tablelist" >
           <template v-for="(v,k) in columns">
               <el-table-column :label="v.label" fixed="left" :key="k" :prop="v.prop" width="160px" v-if="v.prop==='DNT'">
               </el-table-column>
               <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" v-else>
                   <template slot-scope="scope">
                       <span v-if="scope.row[v.prop].toString()==='true'">true</span>
                       <span v-else-if="scope.row[v.prop].toString()==='false'">false</span>
                       <span v-else>{{scope.row[v.prop]}}</span>
                   </template>
               </el-table-column>
           </template>
       </el-table>
       <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
       <div v-if="infoDialogVisible">
           <el-dialog title="关注字段" :visible.sync="infoDialogVisible"
                      :close-on-click-modal="false"
                      :close-on-press-escape="false"
                      :destroy-on-close="true"
                      width="70%"
                      @close="handleCloseInfo">
               <SetField :deviceInfo="deviceInfo" :isGrid="true" @updateCol="update"></SetField>
           </el-dialog>
       </div>
   </div>
</template>

<script>
//import { mapGetters } from 'vuex'
import {deviceGrid, deviceInfo} from '@/api/device'
import { timeFormat } from '@/utils/common'
import Pagination from '@/components/pagination'
import SetField from '@/components/focusFields/index'
export default {
   name: '',
   components: {
        Pagination,SetField
   },
   data() {
      return {
         tablelist: [],
         columns: [],
         treeTableHeight: 650,
         queryInfo: {
            pagesize: 20,
            pagenum: 1,
            date: '',
            pid:null
         },
         total: 0,
         pickerOptions: {
            disabledDate(time) {
               return time.getTime() > Date.now();
            },
            shortcuts: [
                {
                   text: '今天',
                   onClick(picker) {
                      picker.$emit('pick', new Date());
                   }
                }, {
                   text: '昨天',
                   onClick(picker) {
                      const date = new Date();
                      date.setTime(date.getTime() - 3600 * 1000 * 24);
                      picker.$emit('pick', date);
                   }
                }, {
                   text: '一周前',
                   onClick(picker) {
                      const date = new Date();
                      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', date);
                   }
                }]
         },
         infoDialogVisible: false,
         timer:null,
         pagenum:1,
         deviceInfo :{}
      }
   },
   methods: {
       handleSizeChange(newSize) {
           this.queryInfo.pagesize = newSize
           this.getGridData()
       },
       /**
       * 分页组件切换页事件处理
       * @param newPage
       */
       handleCurrentChange(newPage) {
           this.queryInfo.pagenum = newPage
           this.getGridData()
       },
       getGridData(){
           let param = {}
           param.current = this.queryInfo.pagenum
           param.size = this.queryInfo.pagesize
           param.date = this.queryInfo.date
           param.pid = this.deviceInfo.id
           console.log('date=',this.queryInfo.date)
           let that=this
           deviceGrid(param,this.deviceInfo.id).then(response => {
               // console.log('项目数据列表',response.data)
               if(response.code!=200){
                   that.tablelist = []
                   that.total = 0
                   that.getHeight()
                   that.$message.error(response.msg)
                   return
               }
               console.log('code!=200')
               that.tablelist = response.data.records
               that.total = response.data.total
               that.getHeight()
               if(that.queryInfo.pagenum===1&&that.tablelist.length>0&&that.tablelist[0].DNT.substring(0,10)===timeFormat(new Date())){
                   that.startTime()
               }else{
                   that.closeTime()
               }
           })
       },
       getHeight() {
           // this.objstyle.height = window.innerHeight - 170 -55 -40 + 'px'
           if(this.tablelist.length>0){
               this.treeTableHeight = window.innerHeight - 60 -40 -40 -20 -32 + 'px'
               console.log(this.treeTableHeight,'>0')
           }else{
               this.treeTableHeight = window.innerHeight - 60 -40 -40 -20 + 'px'
               console.log(this.treeTableHeight,'!>0')
           }
       },
       init(){
           this.queryInfo.date = timeFormat(new Date())
           // console.log(this.queryInfo.date)
           // console.log('表格init字段',this.deviceInfo.gridStruct)
           if(this.deviceInfo.gridStruct===undefined){
               this.deviceInfo.gridStruct = this.deviceInfo.projectStruct
           }
           //console.log('gridStruct',this.deviceInfo.gridStruct)
           let gridStructArr = []
           if(this.deviceInfo.gridStruct){
               gridStructArr = this.deviceInfo.gridStruct.trim().split(',')
           }
           //let cols=[]
           // console.log('pair',this.deviceInfo.pair)
           gridStructArr.forEach(v=>{
               this.columns.push({prop: v,label: this.deviceInfo.pair[v]})
           })
           //console.log('columns=',this.columns)
       },
       changeData(){
           this.getGridData()
       },
       showSetDialog(){
           this.infoDialogVisible = true
       },
       handleCloseInfo() {
           this.infoDialogVisible = false
       },
       update(val){
           console.log(val)
           this.handleCloseInfo()
           this.closeTime()
           this.columns=[]
           this.tablelist = []
           //this.total=0
           //console.log('最近分页信息=',this.queryInfo)
           /*this.init()
           this.getGridData()*/
           this.getDeviceInfo()
       },
       startTime(){
           let that=this
           this.timer = setInterval(()=>{
               /*dataLast(that.deviceInfo.id,{type:'grid'}).then(response => {
                   if(response.code!=200){
                       console.log(response.msg)
                   }else{
                        if(response.data.DNT!=that.tablelist[0].DNT){
                            that.tablelist.unshift(response.data)
                            that.total = this.total+1
                            // console.log('添加ji;l')
                        }
                   }
               })*/
               let param = {}
               param.current = that.queryInfo.pagenum
               param.size = that.queryInfo.pagesize
               param.date = that.queryInfo.date
               param.pid = that.deviceInfo.id
               deviceGrid(param,that.deviceInfo.id).then(response => {
                   if(response.code!=200){
                       that.getHeight()
                       return that.$message.error(response.msg)
                   }
                   that.tablelist = response.data.records
                   that.total = response.data.total
                   that.getHeight()
               })
           },60*1000)
       },
       closeTime(){
           if (this.timer) {
               clearInterval(this.timer); //关闭
               console.log('销毁定时器')
           }
       },
       getDeviceInfo(){
           let pid=Number(this.$route.query.pid)
           deviceInfo({pid:pid}).then(response => {
               if(response.code!=200){
                   this.$message.error(response.msg)
               }else{
                   this.deviceInfo = response.data
                   // console.log(this.deviceInfo)
                   this.init()
                   window.addEventListener('resize', this.getHeight)
                   this.getGridData()
               }
           })
       }
   },
   computed: {
      /*...mapGetters([
         'deviceInfo'
      ])*/
   },
   created(){
       console.log(this.$router)
       console.log(this.$route)
       this.getHeight()

       this.getDeviceInfo()
   },
   beforeDestroy() {
      this.closeTime()
   },
   activated(){
       this.$refs.xTable.doLayout()
   }
}
</script>

<style scoped>

</style>
